import React, { useContext } from "react";
//import PropTypes from 'prop-types';

import {
    ListItem as BaseListItem,
    MenuItems as BaseMenuItems,
} from "playground/cms/views/Resources";
import PlanEditorContext from "../PlanEditorContext";
import IconButton from "components/IconButton";

export function ListItem(props) {
    const {} = props;
    const showPlanEditor = useContext(PlanEditorContext);
    return (
        <BaseListItem {...props}>
            <IconButton
                icon={"mui-open_in_new"}
                onClick={() => showPlanEditor(true)}
                label={"Edytor"}
            />
        </BaseListItem>
    );
}

ListItem.propTypes = {};

ListItem.defaultProps = {};

export default ListItem;
